// Outbrain Pixel
// https://wavesaudio.atlassian.net/browse/DSWEB-4134

import { getGdprCookie } from '../../projects/gdpr/domain/gdpr-provider';

declare global {
    interface Window {
        obApi: any;
    }
}

export const outbrainPurchaseEvent = () => {
    if(!window.obApi) return;

    const gdpr = getGdprCookie();
    if(!gdpr.IsMarketing) return;

    window.obApi('track', 'Purchase');
    console.log('outbrain purchase event');
};

export const outbrainAddToCartEvent = () => {
    if(!window.obApi) return;

    const gdpr = getGdprCookie();
    if(!gdpr.IsMarketing) return;

    window.obApi('track', 'Add to cart');
    console.log('outbrain add to cart event');
};

export const outbrainRegistrationEvent = () => {
    if(!window.obApi) return;

    const gdpr = getGdprCookie();
    if(!gdpr.IsMarketing) return;

    window.obApi('track', 'Registration');
    console.log('outbrain registration event');
};

export const outbrainLead = () => {
    if(!window.obApi) return;
    window.obApi('track', 'Email sign up');
};